import { Button, Container, Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import styles from '../style.module.scss';

import { ReactComponent as RightArrow } from '../images/arrow-right.svg';

import ProgressBar from 'react-customizable-progressbar';
import slides from '../slides.js';

const OnboardingContentComponent = (props) => {
  const { id, image, title, description } = props.item;
  return (
    <div className={`${styles.contentContainer}`}>
      <div className={`${styles.textContainer}`}>
        <h1 className={styles.mainText}>{title}</h1>
        <h1 className={styles.secondaryText}>{description}</h1>
        <div className={`d-flex align-items-center`}>
          <ProgressBar
            className={`${styles.progressBar}`}
            radius={30}
            progress={props.currentPage * 25}
            strokeWidth={2}
            strokeColor="#22C0E7"
            strokeLinecap="square"
            trackStrokeWidth={2}
            trackStrokeColor="#C0F8FF"
          >
            <div onClick={props.onNextClick} className={`${styles.nextArrow}`}>
              <RightArrow />
            </div>
          </ProgressBar>
          <button onClick={props.onSkip} className={`${styles.noBgButton}`}>
            <span className={`${styles.smallSemibold} ${styles.cursorP} ${styles.disabledText}`}>
              Skip
            </span>
          </button>
        </div>
      </div>
      <div>
        <img className={`${styles.itemImage}`} src={image} />
        <div className={`${styles.carouselContainer}`}>
          {slides.map((slide, index) => {
            return (
              <div
                className={
                  props.currentPage == slide.id ? `${styles.currentSlide}` : `${styles.otherSlide}`
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default OnboardingContentComponent;
